// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"ea803338","587":"fe3dbab9","673":"10a7ba48"}[chunkId] + ".chunk.css";
};